var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:['thumbemote', 'thumbemote--' + _vm.props.face]})}
var staticRenderFns = []

export { render, staticRenderFns }